import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const CarIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 44.039 42.101',
  ...rest
}) => (
  <SvgIcon
    {...rest}
    style={{ width: 44.039, height: 42.101 }}
    viewBox={viewBox}
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-441.187 -85.878)"
    >
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M477.106,111.35a9.109,9.109,0,0,0-9.091-8.6h-3.008a9.109,9.109,0,0,0-9.091,8.6,3.554,3.554,0,0,0-3.258,3.535V121.7h27.706v-6.816A3.554,3.554,0,0,0,477.106,111.35Z"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M457.813,126.979h0a1.932,1.932,0,0,1-1.933-1.933V121.7h3.866v3.345A1.933,1.933,0,0,1,457.813,126.979Z"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M475.21,126.979h0a1.932,1.932,0,0,1-1.933-1.933V121.7h3.866v3.345A1.933,1.933,0,0,1,475.21,126.979Z"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.201"
        cy="2.201"
        r="2.201"
        transform="translate(455.611 114.412)"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.201"
        cy="2.201"
        r="2.201"
        transform="translate(473.021 114.424)"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M5.088,0H9.132a5.088,5.088,0,0,1,5.088,5.088V5.3a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.088A5.088,5.088,0,0,1,5.088,0Z"
        transform="translate(459.3 105.981)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        y1="28.139"
        transform="translate(447.896 98.378)"
      />
      <rect
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        width="11.419"
        height="11.419"
        transform="translate(442.187 86.878)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="42.039"
        transform="translate(442.187 126.979)"
      />
      <g transform="translate(-0.012 0.984)">
        <path
          fill="#224060"
          d="M448.088,92.312H446.8v1.962a.919.919,0,0,1-.2.639.7.7,0,0,1-1.012,0,.911.911,0,0,1-.194-.631V88.94a.876.876,0,0,1,.212-.662.973.973,0,0,1,.677-.2h1.8a4.723,4.723,0,0,1,1.23.123,1.826,1.826,0,0,1,.735.393,1.753,1.753,0,0,1,.471.671,2.369,2.369,0,0,1,.161.894,1.974,1.974,0,0,1-.653,1.6A2.969,2.969,0,0,1,448.088,92.312Zm-.34-3.178H446.8v2.118h.946a2.808,2.808,0,0,0,.83-.1.966.966,0,0,0,.508-.34,1.017,1.017,0,0,0,.175-.62,1.052,1.052,0,0,0-.269-.747A1.8,1.8,0,0,0,447.748,89.134Z"
        />
      </g>
    </g>
  </SvgIcon>
);

export default CarIcon;
